import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import cx from 'classnames/dedupe';
import './index.css';
var View = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    style = props.style,
    rest = __rest(props, ["className", "style"]);
  return /*#__PURE__*/React.createElement("div", Object.assign({}, rest, {
    ref: ref,
    className: cx('one-view', className),
    style: style
  }));
});
View.displayName = 'View';
export default View;